import { isCountryLevel, isHotelTrip } from "@ckgo2/shared";
import type { EditorHintRegistry, HintVariant, TabWebTarget } from "./types";

/**
 * Varianta editoru destinace. Země je každý řádek zemské úrovně (`isCountryLevel`), tedy i místo
 * prezentované jako země (Bali). Vlastní kopie pravidla tu není, rozhoduje sdílený predikát.
 */
export function destinationVariant(row: {
  parentId?: string | null;
  showAsCountry?: boolean | null;
}): "country" | "place" {
  return isCountryLevel(row) ? "country" : "place";
}

/** Varianta editoru zájezdu: hotel podle sdíleného `isHotelTrip`, jinak zájezd. */
export function tripVariant(row: Parameters<typeof isHotelTrip>[0]): "trip" | "hotel" {
  return isHotelTrip(row) ? "hotel" : "trip";
}

/**
 * Vykresluje se pole ve variantě? Omezuje jen výslovné `showIn` záznamu. Pole bez záznamu
 * v registru se neskrývá: chybějící záznam je nález měřidla (AK1), ne důvod pole tiše schovat.
 */
export function fieldVisible(
  registry: EditorHintRegistry,
  field: string,
  variant: HintVariant,
): boolean {
  const showIn = registry.fields[field]?.showIn;
  return showIn === undefined || showIn.includes(variant);
}

/**
 * Druh nápovědy pole ve variantě: `variantKind` varianty, jinak druh záznamu; `null` bez záznamu.
 * Podle něj `FieldHint` volí předponu a měřidlo tvar textu (AK3) i sloupec druhu v tabulce polí.
 */
export function fieldHintKind(
  registry: EditorHintRegistry,
  field: string,
  variant: HintVariant,
): "web" | "backoffice" | null {
  const record = registry.fields[field];
  if (!record) return null;
  return record.variantKind?.[variant] ?? record.kind;
}

/**
 * Cíl odkazu „Zobrazit na webu“ záložky ve variantě. Chybějící cíl znamená, že záložka ve variantě
 * odkaz nemá (`{ notShown: true }`); úplnost cílů pro záložky z `TABS` hlídá měřidlo (AK7 a).
 */
export function tabWebTarget(
  registry: EditorHintRegistry,
  tab: string,
  variant: HintVariant,
): TabWebTarget {
  return registry.tabs[tab]?.[variant] ?? { notShown: true };
}
